<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <v-layout row>
        <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
          <i-card-top
            class="d-flex"
            :useBtnList="buttonUseList"
            @btnAdd="btnAdd()"
            @btnSearch="btnSearch()"
            @btnSave="btnSave()"
            @btnDelete="btnDelete()"
          >
            <template v-slot:body>
              <v-layout overflow-auto>
                <v-row no-gutters class="pa-2"></v-row>
              </v-layout>
            </template>
          </i-card-top>
        </v-col>
        <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
          <i-card-vertical headerTitle="고객 관리" device="web">
            <template v-slot:body>
              <v-layout column overflow-auto>
                <v-col cols="12" md="12" class="row pa-0">
                  <v-col cols="12" class="pa-0">
                    <DxDataGrid
                      id="clientDataGrid"
                      class="layout-col-height00"
                      :ref="dxDataGridRef"
                      :data-source="clients"
                      :remote-operations="false"
                      :hover-state-enabled="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      :column-auto-width="true"
                      :show-borders="true"
                      :show-row-lines="true"
                      :selection="{ mode: 'single' }"
                      key-expr="id"
                      :focused-row-enabled="true"
                      @row-updating="onRowUpdating"
                      @editing-start="onEditingStart"
                      @editor-preparing="onEditorPreparing"
                    >
                      <DxEditing
                        mode="batch"
                        :allow-updating="true"
                        :select-text-on-edit-start="true"
                      />

                      <DxSelection
                        select-all-mode="allPages"
                        show-check-boxes-mode="always"
                        mode="multiple"
                      />

                      <DxColumn
                        data-field="clntId"
                        data-type="string"
                        width="100px"
                        alignment="left"
                        caption="고객 번호"
                        css-class="devest-grid-header-require"
                      />

                      <DxColumn
                        data-field="clntNm"
                        data-type="string"
                        width="100px"
                        caption="고객명"
                        alignment="left"
                        css-class="devest-grid-header-require"
                      />

                      <DxColumn
                        data-field="clntNmEn"
                        data-type="string"
                        width="100px"
                        caption="고객명(영문)"
                      />

                      <DxColumn
                        data-field="rpstNm"
                        data-type="string"
                        width="100px"
                        alignment="left"
                        caption="대표자"
                        css-class="devest-grid-header-require"
                      />

                      <DxColumn
                        data-field="rgstNo"
                        data-type="string"
                        width="110px"
                        alignment="left"
                        caption="사업자등록번호"
                        css-class="devest-grid-header-require"
                      ></DxColumn>

                      <DxColumn
                        data-field="corpNo"
                        data-type="string"
                        width="120px"
                        alignment="left"
                        caption="법인등록번호"
                      ></DxColumn>
                      <DxColumn
                        data-field="detailCd"
                        data-type="string"
                        alignment="left"
                        width="150px"
                        caption="업종코드"
                        css-class="devest-grid-header-require"
                        edit-cell-template="customGrid"
                      ></DxColumn>
                      <template #customGrid="{ data: cellInfo }">
                        <CustomDropBoxGridTemplate
                          :cellInfo="cellInfo"
                          :dataSource="bizList"
                          :options="gridTemplateOpts"
                          @onSelectionChanged="onSelectionChanged"
                        />
                      </template>

                      <DxColumn
                        data-field="detailNm"
                        data-type="string"
                        alignment="left"
                        caption="업종명"
                        css-class="devest-grid-header-require"
                        :allow-editing="false"
                      />
                      <DxColumn
                        data-field="email"
                        data-type="string"
                        alignment="left"
                        width="200px"
                        caption="이메일"
                        css-class="devest-grid-header-require"
                      />

                      <DxColumn
                        data-field="telNo"
                        data-type="string"
                        alignment="left"
                        caption="전화번호"
                      ></DxColumn>

                      <DxColumn
                        data-field="zipCd"
                        data-type="string"
                        width="200px"
                        alignment="center"
                        caption="우편번호"
                        cell-template="PostBoxTemplate"
                        edit-cell-template="PostBoxEditor"
                      />

                      <DxColumn
                        data-field="addrs1"
                        data-type="string"
                        width="250px"
                        alignment="left"
                        caption="주소"
                      />

                      <DxColumn
                        data-field="addrs2"
                        data-type="string"
                        alignment="left"
                        caption="상세주소"
                      />

                      <DxColumn
                        data-field="addrsEn1"
                        data-type="string"
                        width="100px"
                        alignment="left"
                        caption="주소(영문)"
                      />

                      <DxColumn
                        data-field="addrsEn2"
                        data-type="string"
                        alignment="left"
                        caption="상세주소(영문)"
                      />

                      <DxColumn
                        data-field="faxNo"
                        data-type="string"
                        alignment="left"
                        caption="팩스번호"
                      ></DxColumn>

                      <DxColumn
                        data-field="natnCd"
                        data-type="string"
                        alignment="center"
                        caption="국가코드"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="bankCd"
                        data-type="string"
                        alignment="center"
                        caption="은행코드"
                      />

                      <DxColumn
                        data-field="bankNo"
                        data-type="string"
                        alignment="left"
                        caption="계좌번호"
                      />

                      <DxColumn
                        data-field="sealFileNm"
                        caption="파일명"
                        data-type="string"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="sealFile"
                        caption="파일"
                        data-type="string"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="sealFileId"
                        caption="파일아이디"
                        data-type="number"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="seal__fileUpdate__"
                        caption="파일수정여부"
                        data-type="boolean"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="seal"
                        :width="80"
                        cell-template="extensionIconTemplate"
                        edit-cell-template="extensionIconTemplate"
                        caption="직인"
                        alignment="left"
                      />

                      <DxColumn
                        data-field="logoFileNm"
                        caption="파일명"
                        data-type="string"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="logoFile"
                        caption="파일"
                        data-type="string"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="logoFileId"
                        caption="파일아이디"
                        data-type="number"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="logo__fileUpdate__"
                        caption="파일수정여부"
                        data-type="boolean"
                        alignment="left"
                        :visible="false"
                      />

                      <DxColumn
                        data-field="logo"
                        :width="80"
                        cell-template="extensionIconTemplate"
                        edit-cell-template="extensionIconTemplate"
                        caption="로고"
                        alignment="left"
                      />

                      <DxColumn
                        data-field="desc"
                        data-type="string"
                        alignment="center"
                        caption="설명"
                      />

                      <template #PostBoxTemplate="{data: cellInfo}">
                        <div
                          v-if="cellInfo.value != '' && cellInfo.value != null"
                          no-gutters
                          class="dx-adaptive-item-text d-flex justify-center align-center"
                        >
                          <div class="pl-1 pr-0">{{ cellInfo.value }}</div>
                          <!-- <v-spacer /> -->
                          <div class="text-right pr-2">
                            <v-btn text icon x-small @click="resetZipCd(cellInfo)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <v-row v-else no-gutters class="dx-adaptive-item-text">
                          <v-col cols="11" class="pl-1 pr-0">{{ cellInfo.value }}</v-col>
                          <v-spacer />
                          <v-col class="text-right pr-2" cols="1"></v-col>
                        </v-row>
                      </template>

                      <template #PostBoxEditor="{ data: cellInfo }">
                        <div>
                          <!-- <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" /> -->
                          <DxDropDownBox
                            id="postCdDropBoxRef"
                            v-model="cellInfo.value"
                            :displayExpr="setPostCd"
                            :ref="postCdDropBoxRefName"
                            :drop-down-options="dropDownOptions"
                            @opened="onOpened"
                            @closed="onClosed"
                            content-template="contentTemplate"
                          >
                            <template #contentTemplate="{}">
                              <vue-daum-postcode
                                v-if="postVisible"
                                style="height: 500px; overflow: scroll;"
                                :animation="false"
                                :no-shorthand="true"
                                :no-auto-mapping="true"
                                :please-read-guide="1"
                                :please-read-guide-timer="1"
                                :max-suggest-items="3"
                                :show-more-h-name="false"
                                :hide-map-btn="true"
                                :hide-eng-btn="true"
                                :always-show-eng-addr="true"
                                :zonecode-only="true"
                                :theme="{
                                  outlineColor: '#44444'
                                }"
                                @onsearch="getSearch($event)"
                                @complete="getAddress($event, cellInfo)"
                              />
                            </template>
                          </DxDropDownBox>
                        </div>
                      </template>

                      <template #extensionIconTemplate="{ data:cellInfo }">
                        <v-row v-if="!cellInfo.data.__created__" no-gutters>
                          <v-col class="pl-2 pt-1 d-flex" cols="8">
                            <span
                              v-if="cellInfo.column.dataField == 'logo'"
                              class="dx-datagrid-content-file-name-text"
                            >
                              {{ cellInfo.data.logoFileNm ? cellInfo.data.logoFileNm + '.' : ' (파일없음)'
                              }}{{ cellInfo.data.logo ? cellInfo.data.logo : '' }}
                            </span>
                            <span
                              v-else-if="cellInfo.column.dataField == 'seal'"
                              class="dx-datagrid-content-file-name-text"
                            >
                              {{ cellInfo.data.sealFileNm ? cellInfo.data.sealFileNm + '.' : ' (파일없음)'
                              }}{{ cellInfo.data.seal ? cellInfo.data.seal : '' }}
                            </span>
                            <span class="pl-2 d-flex">
                              <div v-if="cellInfo.value == '' || cellInfo.value == null" />

                              <svg-icon
                                class="jpg_icon mr-2"
                                v-else-if="cellInfo.value == 'jpg' || cellInfo.value == 'jpeg'"
                                icon-class="jpg"
                              />

                              <svg-icon
                                class="pdf_icon mr-2"
                                v-else-if="cellInfo.value == 'pdf'"
                                icon-class="pdf"
                              />

                              <svg-icon
                                class="png_icon mr-2"
                                v-else-if="cellInfo.value == 'png'"
                                icon-class="png"
                              />

                              <svg-icon
                                class="file_default_icon ml-2"
                                v-else
                                icon-class="file_default"
                              />

                              <v-btn
                                v-if="cellInfo.value"
                                elevation="0"
                                color="btn_sub"
                                dark
                                x-small
                                @click="fileDownload(cellInfo.column.dataField, cellInfo.data)"
                              >
                                <!-- <svg-icon icon-class="download"></svg-icon> -->
                                다운로드
                              </v-btn>
                            </span>
                          </v-col>
                          <v-col align="right" cols="4">
                            <v-btn
                              icon
                              v-if="cellInfo.value"
                              role="clear"
                              @click="clearClick(cellInfo)"
                            >
                              <svg-icon icon-class="close"></svg-icon>
                            </v-btn>
                            <v-btn
                              elevation="0"
                              color="btn_sub"
                              dark
                              x-small
                              class="pa-1 mr-2"
                              role="upload"
                              @click="uploadClick(cellInfo)"
                            >
                              <!-- <svg-icon icon-class="upload"></svg-icon> -->
                              업로드
                              <!-- 업로드 -->
                            </v-btn>
                          </v-col>
                        </v-row>
                      </template>
                    </DxDataGrid>

                    <DxFileUploader
                      :ref="dxSealFileloaderRef"
                      :multiple="false"
                      upload-mode="useButton"
                      :visible="false"
                      @value-changed="onFileValueChanged"
                    />

                    <DxFileUploader
                      :ref="dxLogoFileloaderRef"
                      :multiple="false"
                      upload-mode="useButton"
                      :visible="false"
                      @value-changed="onFileValueChanged"
                    />
                  </v-col>
                </v-col>
              </v-layout>
            </template>
          </i-card-vertical>
        </v-col>
      </v-layout>
    </v-row>
  </v-container>
</template>

<script>
import { DxPatternRule } from 'devextreme-vue/data-grid'
import { getClientList, saveClient, deleteClient, getBizList } from '@/api/setting/clientManage'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { multiUpload, downloadFile, getFile } from '@/api/baseManage/fileUpload'
import { getExtension } from '@/utils/common.js'

import DxDropDownBox from 'devextreme-vue/drop-down-box'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify'
import DxDateBox from 'devextreme-vue/date-box'
import CustomDropBoxGridTemplate from '@/components/dxDataGrid/CustomDropBoxGridTemplate.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'ClientManage',
  components: {
    DxDropDownBox,
    DxPatternRule,
    DxFileUploader,
    CustomDropBoxGridTemplate
  },
  data() {
    return {
      dxSealFileloaderRef: 'sealFileUploaderRef',
      dxLogoFileloaderRef: 'logoFileUploaderRef',
      pageSizes: [5],
      showPageSizeSelector: false,
      dxDataGridRef: 'clientDataGrid',
      clients: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      status: '고객 정보',
      // phonePattern: /^\d{3}-(\d{4}||\d{3})-\d{4}$/i,
      rgstNoPattern: /^\d{3}-\d{2}-\d{5}$/i,
      corpNoPattern: /^\d{6}-\d{7}$/i,
      clntIdPattern: /^[A-Za-z0-9]{1,10}$/i,
      emailPattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i,
      dropDownOptions: { width: 350 },
      postCdDropBoxRefName: 'postCdDropBoxRef',
      allowedFileExtensions: ['jpg', 'jpeg', 'gif', 'png'],
      currentValue: '',
      postVisible: false,
      bizList: [], // 업종코드 정보
      gridTemplateOpts: {
        dropBoxWidth: '500px',
        gridWidth: '100%',
        displayExpr: 'detailCd',
        valueExpr: 'detailCd',
        keyExpr: 'detailCd',
        selectionMode: 'single',
        columns: [
          {
            fieldCd: 'detailCd',
            fieldNm: '업종코드',
            width: '200px'
          },
          {
            fieldCd: 'detailNm',
            fieldNm: '업종명',
            width: '250px'
          }
        ],
        paging: true,
        pagingSize: 5
      }
    }
  },
  computed: {},
  beforeMount() {},
  mounted() {
    this.btnSearch()
    getBizList(true)
      .then(res => {
        if (res.success) {
          console.log('##res ==> ', res)
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.bizList = res.list
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
        }
      })
      .catch(error => {})
      .finally(() => {
        this.endLoading()
      })
  },
  methods: {
    ///////////////////////////////////////
    /*        postcode Box Event         */
    ///////////////////////////////////////
    //dropDown이 열릴때 타는 이벤트
    onOpened(e) {
      this.postVisible = true
    },
    //dropDown이 닫힐때 타는 이벤트
    onClosed(e) {
      this.postVisible = false
    },
    //우편번호를 화면에 표시해주는 함수
    setPostCd() {
      return this.$refs[this.postCdDropBoxRefName].value
    },
    getSearch(e) {},
    //우편번호 선택 완료시 타는 이벤트
    getAddress(e, cellInfo) {
      this.currentValue = e.zonecode

      //선택된 우편번호에 대한 정보를 설정
      this.GetDataGrid(this.dxDataGridRef).cellValue(cellInfo.rowIndex, 'zipCd', e.zonecode)
      this.GetDataGrid(this.dxDataGridRef).cellValue(cellInfo.rowIndex, 'addrs1', e.address)
      this.GetDataGrid(this.dxDataGridRef).cellValue(cellInfo.rowIndex, 'addrsEn1', e.addressEnglish)

      cellInfo.component.updateDimensions()
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.key, true)
      this.GetDataGrid(this.dxDataGridRef).saveEditData()
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  고객 조회
    //------------------------------------------
    btnSearch() {
      this.openLoading('searching')

      this.clients = []
      getClientList({ validOnly: true }, true)
        .then(res => {
          if (res.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.clients = res.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch(error => {})
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  고객 추가
    //------------------------------------------
    btnAdd() {
      let newRow = {
        id: this.clients.length + 1,
        zipCd: null,
        addrs1: '',
        addrs2: '',
        addrsEn1: '',
        addrsEn2: '',
        natnCd: 'KR',
        rgstNo: '',
        corpNo: '',
        faxNo: '',
        telNo: ''
      }

      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    //------------------------------------------
    //  고객 저장
    //------------------------------------------
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'warn')
            return
          }

          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              //필수입력값 체크
              var pattern = /\s/g
              var index = selectedRows.findIndex(
                element =>
                  element.clntId == null ||
                  element.clntNm == null ||
                  element.rgstNo == null ||
                  element.rpstNm == null ||
                  element.detailCd == null ||
                  element.detailNm == null ||
                  element.email == null ||
                  element.clntId == '' ||
                  element.clntNm == '' ||
                  element.rgstNo == '' ||
                  element.rpstNm == '' ||
                  element.detailCd == '' ||
                  element.detailNm == '' ||
                  element.email == '' ||
                  element.clntId.match(pattern) != null
              )

              if (index >= 0) {
                this.vToastify(this.$t('필수항목 입력하세요.<br>[고객 번호, 고객명, 대표자, 사업자등록번호, 업종코드, 업종명, 이메일]'), 'warn')
                this.GetDataGrid(this.dxDataGridRef).endUpdate()
                return
              }

              //유효성검사
              var valid = ''
              var patternIndex = selectedRows.findIndex(element => {
                if (element.clntId.match(this.clntIdPattern) == null) {
                  valid = 'clntId'
                  return true
                } else if (element.rgstNo.match(this.rgstNoPattern) == null) {
                  valid = 'rgstNo'
                  return true
                } else if (element.corpNo.match(this.corpNoPattern) == null && element.corpNo != '') {
                  valid = 'corpNo'
                  return true
                } else if (element.email.match(this.emailPattern) == null) {
                  valid = 'email'
                  return true
                }
              })

              //유효성 검사에서 걸리는 경우 띄우는 경고창
              if (patternIndex >= 0) {
                this.vToastify(
                  valid == 'clntId'
                    ? this.$t('고객번호는 5자리입니다.')
                    : valid == 'rgstNo'
                    ? this.$t('올바르지 않은 사업자등록번호 형식입니다.')
                    : valid == 'corpNo'
                    ? this.$t('올바르지 않은 법인등록번호 형식입니다.')
                    : valid == 'email'
                    ? this.$t('올바르지 않은 이메일 형식입니다.')
                    : this.$t(''),
                  'warn'
                )
                this.GetDataGrid(this.dxDataGridRef).endUpdate()
                return
              }

              let fileData = []
              //고객명 및 대표자명 앞뒤 공백제거
              selectedRows.forEach(element => {
                element.clntNm = element.clntNm.trim()
                element.rpstNm = element.rpstNm.trim()

                if (
                  (element.sealFile != null && element.sealFile != '' && element.seal__fileUpdate__) ||
                  (element.logoFile != null && element.logoFile != '' && element.logo__fileUpdate__)
                ) {
                  fileData.push(element)
                }
              })

              //저장 api
              this.openLoading('saving')
              saveClient(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    if (fileData.length !== 0) {
                      this.saveFile(fileData).then(res => {
                        this.btnSearch(false)
                      })
                    } else {
                      this.btnSearch(false)
                    }
                  }
                })
                .catch(error => {
                  if (error.response && error.response.data) {
                    if (error.response.data.code == -2001) {
                      this.vToastify(this.$t(error.response.data.msg), 'warn')
                    }
                  }
                })
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  고객 삭제
    //------------------------------------------
    btnDelete() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'warn')
            return
          }

          this.vToastifyPrompt(
            this.$t('고객을 삭제하시겠습니까?'),
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              this.openLoading('deleting')
              //삭제 api
              deleteClient(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    this.deleteCallBack(selectedRows)
                  }
                })
                .catch(error => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {
      if (e.column.dataField == 'clntId' && !e.data.__created__) e.cancel = true
      else if (e.column.dataField == 'addrs1' || e.column.dataField == 'addrsEn1') e.cancel = true
      else e.cancel = false
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(param) {
      var index = null
      param.forEach(key => {
        index = this.clients.findIndex(obj => obj == key)
        this.clients.splice(index, 1)
      })
    },
    //우편번호 삭제 버튼 클릭 시 타는 이벤트
    resetZipCd(e) {
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.rowIndex, 'zipCd', '')
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.rowIndex, 'addrs1', null)
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.rowIndex, 'addrsEn1', null)
    },
    ///////////////////////////////////////
    /*          fileUpload Event         */
    ///////////////////////////////////////
    async onFileValueChanged(e) {
      let file = e.value[0]
      // file 객체를 data에 넣으면 Error로 인하여 file을 string으로 변환 후 넣음
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        // 확장자랑 파일명 가져오기
        let subFileName = getExtension(file.name)

        let index = this.allowedFileExtensions.findIndex(element => element == subFileName[1])

        if (index < 0) {
          notify(this.$t('업로드할 수 없는 확장자입니다.'), 'error', 300)
          return
        }
        // console.log(subFileName)
        let rowIndex = this.currentCellInfo.row.rowIndex

        this.GetDataGrid(this.dxDataGridRef).cellValue(rowIndex, this.currentCellInfo.column.dataField, subFileName[1])
        this.GetDataGrid(this.dxDataGridRef).cellValue(rowIndex, this.currentCellInfo.column.dataField + 'FileNm', subFileName[0])
        this.GetDataGrid(this.dxDataGridRef).cellValue(rowIndex, this.currentCellInfo.column.dataField + 'File', reader.result)
        this.GetDataGrid(this.dxDataGridRef).cellValue(rowIndex, this.currentCellInfo.column.dataField + '__fileUpdate__', true)

        let a = this.GetDataGrid(this.dxDataGridRef).option('editing.changes')
        console.log(this.currentCellInfo.column.dataField + 'FileNm')

        // 수정된 값 표시를 위해 클래스 추가
        // 포커싱이 아웃되면 클래스가 사라짐 개선 필요
        // let cellElement = this.GetDataGrid(this.dxDataGridDetailRef).getCellElement(rowIndex, this.currentCellInfo.columnIndex)
        // let className = ['dx-item-modified', 'dx-cell-modified']
        // cellElement.classList.add(...className)

        this.GetDataGrid(this.dxDataGridRef).selectRows(this.currentCellInfo.key, true)
      }
      reader.onerror = error => {
        console.log('error', error)
        // this.$vToastify.error({ body: '파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.' })
        this.vToastify(this.$t('파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.'), 'error')
      }
    },
    uploadClick(e) {
      // 클릭했을 때 해당 열의 데이터를 들고 옴
      this.currentCellInfo = e
      let fileInstance = this.$refs[this.dxLogoFileloaderRef].instance
      let fileElement = fileInstance.element()
      let uploadButton = fileElement.querySelector(`.dx-button-content`)
      uploadButton.click()
    },
    clearClick(e) {
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.row.rowIndex, e.column.dataField, '')
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.row.rowIndex, e.column.dataField + 'FileNm', '')
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.row.rowIndex, e.column.dataField + 'File', '')
      this.GetDataGrid(this.dxDataGridRef).cellValue(e.row.rowIndex, e.column.dataField + '__fileUpdate__', true)

      this.GetDataGrid(this.dxDataGridRef).selectRows(e.key, true)
    },

    saveFile(selectedDetailRows) {
      console.log('#######', selectedDetailRows)
      return new Promise((resolve, reject) => {
        selectedDetailRows.forEach(element => {
          // string변환된 파일을 다시 File 객체로
          if (element.sealFile != null && element.sealFile != '') {
            let arr = element.sealFile.split(','),
              mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]),
              n = bstr.length,
              u8arr = new Uint8Array(n)

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }
            let file = new File([u8arr], `${element.sealFileNm}.${element.seal}`, { type: mime })

            // form 데이터로 전송
            let formData = new FormData()

            formData.append('files[]', file)
            let fileVO = {
              // clntId: this.getClntId(),
              clntId: element.clntId,
              targetId: 'seal_' + element.clntId,
              targetType: 'client_seal',
              useYn: 'Y'
            }

            formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))
            multiUpload(formData, false)
              .then(res => {
                notify(this.$t('Save.success'), 'success', 300)
              })
              .finally(() => {
                resolve(true)
              })
          }
          if (element.logoFile != null && element.logoFile != '') {
            let arr = element.logoFile.split(','),
              mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]),
              n = bstr.length,
              u8arr = new Uint8Array(n)

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n)
            }
            console.log(element)
            let file = new File([u8arr], `${element.logoFileNm}.${element.logo}`, { type: mime })

            // form 데이터로 전송
            var formData = new FormData()

            formData.append('files[]', file)

            let fileVO = {
              // clntId: this.getClntId(),
              clntId: element.clntId,
              targetId: 'logo_' + element.clntId,
              targetType: '00001',
              useYn: 'Y'
            }

            formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))
            multiUpload(formData, false)
              .then(res => {
                notify(this.$t('Save.success'), 'success', 300)
              })
              .finally(() => {
                resolve(true)
              })
          }
        })
      })
    },
    fileDownload(dataField, e) {
      if (dataField == 'logo') {
        // 올리지 않은 상태로 파일을 다운 받는 경우
        if (e.logoFile != null && e.logoFile !== '') {
          let link = document.createElement('a')
          link.href = e.logoFile
          link.download = `${e.logoFileNm}.${e.logo}`
          link.click()
        } else {
          this.openLoading()
          let getParams = {
            clntId: this.getClntId(),
            targetType: 'client_' + dataField,
            targetId: dataField + '_' + this.getClntId()
          }
          getFile(getParams).then(response => {
            if (response.list) {
              let params = {
                clntId: response.list[0].clntId,
                writeDt: response.list[0].writeDt,
                docNo: response.list[0].docNo
              }
              downloadFile(params)
                .then(res => {
                  console.log(res)
                  let link = document.createElement('a')
                  // 객체를 만들어서 생성
                  let objectUrl = window.URL.createObjectURL(res)
                  link.href = objectUrl
                  link.download = `${response.list[0].fileNm}.${response.list[0].extension}`
                  link.click()
                })
                .finally(() => this.endLoading())
            } else {
              this.endLoading()
            }
          })
        }
      } else {
        // 올리지 않은 상태로 파일을 다운 받는 경우
        if (e.sealFile != null && e.sealFile !== '') {
          let link = document.createElement('a')
          link.href = e.sealFile
          link.download = `${e.sealFileNm}.${e.seal}`
          link.click()
        } else {
          this.openLoading()
          let getParams = {
            clntId: this.getClntId(),
            targetType: 'client_' + dataField,
            targetId: dataField + '_' + this.getClntId()
          }
          getFile(getParams).then(response => {
            if (response.list) {
              let params = {
                clntId: response.list[0].clntId,
                writeDt: response.list[0].writeDt,
                docNo: response.list[0].docNo
              }
              downloadFile(params)
                .then(res => {
                  let link = document.createElement('a')
                  // 객체를 만들어서 생성
                  let objectUrl = window.URL.createObjectURL(res)
                  link.href = objectUrl
                  link.download = `${response.list[0].fileNm}.${response.list[0].extension}`
                  link.click()
                })
                .finally(() => this.endLoading())
            } else {
              this.endLoading()
            }
          })
        }
      }
    },
    onSelectionChanged(e, cellInfo) {
      // cellInfo.setValue(e.selectedRowKeys[0])

      let biz = this.bizList.find(el => el.detailCd == e.selectedRowKeys[0])
      cellInfo.component.cellValue(cellInfo.row.rowIndex, 'detailCd', biz.detailCd)
      cellInfo.component.cellValue(cellInfo.row.rowIndex, 'detailNm', biz.detailNm)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dx-box-item-content {
  height: 32px !important;
}
</style>
